module.exports = __webpack_public_path__ + "is.svg?d2d3cb26e484d0f5a1d6b469f5683a2c";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/is.svg
// module id = 1284
// module chunks = 27